import React, { useState } from 'react';

import {
  Button,
  AppBar,
  Toolbar,
  TextField,
  Menu,
  MenuItem
} from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  ExitToApp as ExitToAppIcon,
} from '@mui/icons-material';

import { useAppSelector, useAppDispatch } from '../../hooks';
import { setStoreSelected } from "../../slices/sessionSlice"
import clsx from 'clsx';
import useStyles from '../../useStyles';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";
import signout from "../../services/signout"


interface Store {
  id: number,
  alias_id?: number | null,
  stores_address?: string,
  store_lat: number,
  store_long: number,
  store_name: string,
  store_services: Array<number>
  store_services_addons: Array<any>
}

export default function TopBar(props: { hideStore?: boolean }) {
  const navigate = useNavigate();
  const store_list = sessionStorage.getItem('stores') ? JSON.parse(sessionStorage.getItem('stores')!) : [];
  const classes = useStyles();
  const [anchorStore, setAnchorStore] = React.useState<null | HTMLElement>(null);
  const [storeSearch, setStoreSearch] = React.useState<string>("");
  const [anchorUsr, setAnchorUsr] = React.useState<null | HTMLElement>(null);
  const [plotStores, setPlotStores] = useState<Store[]>(store_list)
  const drawerOpen = useAppSelector(state => state.drawer.open);
  const storeSelected = useAppSelector(state => state.session.storeSelected)

  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (storeSearch === '') {
      setPlotStores(store_list)
      return
    }
    let newStores = store_list.filter((store) => store.store_name.toLowerCase().includes(storeSearch))
    setPlotStores(newStores)
    // eslint-disable-next-line
  }, [storeSearch]);

  const handleChangeText = (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let text = evt.target.value.toLowerCase();
    setStoreSearch(text);
  }


  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}>
        <Toolbar className={classes.toolbar} style={{
          display: "flex"
        }}>
          <div style={{
            marginLeft: "auto"
          }}>
            {!props.hideStore &&
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={(event) => { setAnchorStore(event.currentTarget); }}
                color="inherit"
              >
                {
                  (typeof (storeSelected) !== 'undefined') ? storeSelected.store_name : 'Selecionar loja'
                }
                <ArrowDropDownIcon />
              </Button>
            }
            <Menu
              id="store-select"
              anchorEl={anchorStore}
              open={Boolean(anchorStore)}
              sx={{ height: 400 }}
              onClose={() => setAnchorStore(null)}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <TextField
                id="text"
                value={storeSearch}
                label="Procurar loja"
                variant="outlined"
                size="small"
                sx={{
                  margin: "10px",
                  position: "sticky"
                }}
                onChange={(evt) => handleChangeText(evt)}
                autoFocus={true}
                onKeyDown={e => e.stopPropagation()}
              />
              {plotStores.map((store, index) => {
                return (
                  <MenuItem
                    onClick={(evt) => {
                      setAnchorStore(null);
                      setStoreSearch('');
                      dispatch(setStoreSelected(store));
                    }}
                    key={index}
                  >
                    {store.store_name}
                  </MenuItem>
                )
              })}
            </Menu>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={(event) => { setAnchorUsr(event.currentTarget); }}
              color="inherit"
            >
              {sessionStorage.username}
              <ArrowDropDownIcon />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorUsr}
              keepMounted
              open={Boolean(anchorUsr)}
              onClose={() => { setAnchorUsr(null); }}
              anchorOrigin={{
                horizontal: "center", vertical: "bottom"
              }}
              // getContentAnchorEl={null}
              transformOrigin={{
                horizontal: "center",
                vertical: "top"
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate('/settings')
                }}
              >
                <SettingsIcon /> Configurações
              </MenuItem>
              <MenuItem
                onClick={() => {
                  signout()
                }}
              >
                <ExitToAppIcon /> Sair
              </MenuItem>
            </Menu>
          </div >
        </Toolbar >
      </AppBar >
    </>
  );
}